import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { RainBanner } from './components/RainBanner';
import { BrandsWeServe } from './components/BrandsWeServe';
import { Gallery } from './components/Gallery';
import { About } from './components/About';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { CallButton } from './components/CallButton';
import { RainOffer } from './components/RainOffer';
import { BmwRepair } from './components/BmwRepair';
import { MercedesRepair } from './components/MercedesRepair';
import { PorscheRepair } from './components/PorscheRepair';
import { AudiRepair } from './components/AudiRepair';
import { VolkswagenRepair } from './components/VolkswagenRepair';
import { LamborghiniRepair } from './components/LamborghiniRepair';
import { FerrariRepair } from './components/FerrariRepair';
import { RollsRoyceRepair } from './components/RollsRoyceRepair';
import { BentleyRepair } from './components/BentleyRepair';
import { LandRoverRepair } from './components/LandRoverRepair';
import { MclarenRepair } from './components/MclarenRepair';
import { AstonMartinRepair } from './components/AstonMartinRepair';
import { JaguarRepair } from './components/JaguarRepair';
import { SpinAndWin } from './components/SpinAndWin';
import { AcService } from './components/AcService';
import { MyInvoice } from './components/MyInvoice';
import { BrandLogoSlider } from './components/BrandLogoSlider';
import { TopAnnouncementBar } from './components/TopAnnouncementBar';
import { Toaster } from './components/ui/sonner';
import './App.css';

const HomePage = () => (
  <>
    <TopAnnouncementBar />
    <Header />
    <main>
      <Hero />
      <BrandsWeServe />
      <Gallery />
      <About />
      <BrandLogoSlider />
      <Services />
      <Testimonials />
      <Contact />
    </main>
    <Footer />
    <CallButton />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/rain-offer" element={<RainOffer />} />
            <Route path="/bmw-repair-dubai" element={<BmwRepair />} />
            <Route path="/mercedes-repair-dubai" element={<MercedesRepair />} />
            <Route path="/porsche-repair-dubai" element={<PorscheRepair />} />
            <Route path="/audi-repair-dubai" element={<AudiRepair />} />
            <Route path="/volkswagen-repair-dubai" element={<VolkswagenRepair />} />
            <Route path="/lamborghini-repair-dubai" element={<LamborghiniRepair />} />
            <Route path="/ferrari-repair-dubai" element={<FerrariRepair />} />
            <Route path="/rollsroyce-repair-dubai" element={<RollsRoyceRepair />} />
            <Route path="/bentley-repair-dubai" element={<BentleyRepair />} />
            <Route path="/landrover-repair-dubai" element={<LandRoverRepair />} />
            <Route path="/mclaren-repair-dubai" element={<MclarenRepair />} />
            <Route path="/astonmartin-repair-dubai" element={<AstonMartinRepair />} />
            <Route path="/jaguar-repair-dubai" element={<JaguarRepair />} />
            <Route path="/car-ac-expert" element={<AcService />} />
            <Route path="/myinvoice" element={<MyInvoice />} />
            <Route path="/spin-and-win" element={<SpinAndWin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
